import client from "api/config";
import { convertNum } from "helper/convert-num";

//////////////////// login ////////////////////
const loginUrl = "/admin";
export const login = (values) => {
  return client.post(loginUrl, {
    user_name: values.name,
    password: values.password,
  });
};
